import React from 'react';
import clsx from 'clsx';
import { useRouter } from '@tribeplatform/react-sdk';
import { Carousel } from '@tribeplatform/react-ui-kit/Carousel';
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader';
import { CallToActionBlock } from '../CallToAction/Block.js';
const colsToWidth = {
    2: '260px',
    3: '170px',
    4: '120px',
    5: '95px',
};
const GridList = ({ children, columns = 3, className = '' }) => {
    const columnsClsx = {
        'web:grid-cols-1 sm:grid-cols-2 lg:grid-cols-2': columns === 2,
        'web:grid-cols-2 sm:grid-cols-3 lg:grid-cols-3': columns === 3,
        'web:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4': columns === 4,
        'web:grid-cols-3 web:lg:grid-cols-5 web:xl:grid-cols-5': columns === 5,
    };
    return (React.createElement("div", { className: clsx('grid gap-4', columnsClsx, className) }, children));
};
export const QuickLinksBlock = ({ alignment, actionType, horizontalScroll, gridCols, title, items, }) => {
    const { Link } = useRouter();
    if (!items) {
        return null;
    }
    const cards = items.map((item, idx) => {
        const style = horizontalScroll
            ? {
                minWidth: colsToWidth[gridCols],
                maxWidth: colsToWidth[gridCols],
            }
            : {};
        if (actionType === 'clickable-card') {
            return (React.createElement(Link, { key: idx, href: item.action.href, target: item.action.openInNewWindow ? '_blank' : undefined, className: clsx('flex', horizontalScroll && 'min-w-40'), style: style },
                React.createElement(CallToActionBlock, Object.assign({ alignment: alignment }, item, { className: clsx('hover:shadow-lg transition-all ease-in-out duration-200 flex-1', horizontalScroll && 'rounded-lg'), action: {
                        href: item.action.href,
                        type: 'link',
                        text: undefined,
                    } }))));
        }
        return (React.createElement(CallToActionBlock, Object.assign({ alignment: alignment }, item, { action: Object.assign(Object.assign({}, item.action), { type: actionType }), key: idx, className: clsx(horizontalScroll && 'min-w-40 rounded-lg'), style: style })));
    });
    return (React.createElement("div", null,
        title && React.createElement(SectionHeader, { title: title !== null && title !== void 0 ? title : '' }),
        horizontalScroll ? (React.createElement(Carousel, { className: "pt-1 pb-4", items: cards })) : (React.createElement(GridList, { columns: gridCols }, cards))));
};
//# sourceMappingURL=Block.js.map